
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import riskReducer from '../../../store/reducers/riskReducer';
import { connect } from "react-redux";
import { compose } from "redux";
import { useHistory, useLocation } from 'react-router-dom'

const TopAssets = ({ height, assets }) => {
  const { t } = useTranslation();
  const risksDemo = [
    { id: 'R-101', name: 'Data Breach', type: 'IT', severity: 'Extreme' },
    { id: 'R-102', name: 'Regulatory Violation', type: 'Compliance', severity: 'High' },
    { id: 'R-103', name: 'System Downtime', type: 'Operational', severity: 'High' },
    { id: 'R-104', name: 'Third-Party Failure', type: 'Operational', severity: 'Moderate' },
    { id: 'R-105', name: 'Improper Access Control', type: 'IT', severity: 'Low' },
  ];

  const history = useHistory()
  const { pathname } = useLocation()

  const [assetList, setassetList] = useState([]); 
   useEffect(() => {
      if (assets) {
          setassetList(assets)
      }
  }, [assets]);

  const getNumber = (damage) => {
    switch (damage) {
      case 'Insignificant':
        return 1;
      case 'Minor':
        return 2;
      case 'Moderate':
        return 3;
      case 'Major':
        return 4;
      case 'Catastrophe':
        return 5;
      default:
        return 0;
    }
  };

  const getMultiply = (probability) => {
    switch (probability) {
      case 'Rare':
        return 1;
      case 'Unlikely':
        return 2;
      case 'Possible':
        return 3;
      case 'Likely':
        return 4;
      case 'Almost certain':
        return 5;
      default:
        return 0;
    }
  };



  const getSeverity = (damage) => {
    const rank = damage 
    //////console.log(damage, " | ", probability, rank, getSeverityColor("Moderate"))
    
    if (rank <= 25) {
      return "Low"
    } else if (rank <= 75) {
     return "Moderate"
    } else if (rank <= 100) {
      return "High"
    } else {
      return "Extreme"
}
  };

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'Extreme':
        return 'text-red-700 font-semibold';
      case 'High':
        return 'text-orange-600 font-semibold';
      case 'Moderate':
        return 'text-yellow-600 font-medium';
      case 'Low':
        return 'text-green-600 font-medium';
      default:
        return '';
    }
  };

   const goToRisk = id => {
    // derive domain segment if needed
    const domain = pathname.split('/')[1] || ''
    // push new URL with risk ID param
    history.push(`/risk/${id}`)
  }

  return (
    <div className="w-full bg-white rounded-lg" style={{ height }}>
      <div className="h-full overflow-y-auto px-4 py-2">
        {assetList.map((asset, index) => (
          <div
            key={index}
            className="flex justify-between items-center py-2 text-xs border-b border-gray-100 hover:bg-gray-200 p-2 rounded-md"
            
          >
            <span className="w-[10%]">{index + 1}</span>
            <span className="w-[40%] truncate text-gray-600 underline-offset-2 cursor-pointer" >{asset.name}</span>
            <span className={`w-[10%] text-right ${getSeverityColor(getSeverity(asset.risk_score))}`}>
              {t(`assetManagement.statsPage.severity.${getSeverity(asset.risk_score).toLowerCase()}`)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};


const mapStateToProps = (state) => {
    ////console.log(state.asset.assets_stat_data)
    return {

        assets: state.asset.assets_stat_data.topAssets,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(TopAssets);